import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';

@Component({
  selector: 'app-mandatory-themes',
  templateUrl: './mandatory-themes.component.html',
  styleUrls: ['./mandatory-themes.component.css']
})
export class MandatoryThemesComponent implements OnInit {

  selectedYearMonth: object = { 'ay': "", "month": "" };
  yearDropDownList: any;
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  yearList:any = [ '2021-2022', '2022-2023', '2023-2024', '2024-2025', '2025-2026', '2026-2027', '2027-2028', '2028-2029', '2029-2030' ];
  themeData: any;
  selectedThemes: any = [];
  activDeactivYear: any = [];
  currentMonthVar: any;
  currentYearVar: any;
  enabledThemes: any;
  activesidetab: any;

  constructor(
    private submitdataSerivce: SubmitdataService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.getdynamicYears();
    this.getCurrentMonth();
    this.navtabclick('thememandate');
  }

  public navtabclick(type) {
    if (type == this.activesidetab)
      return
    this.activesidetab = type;
  }

  getdynamicYears() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if (currentmonth < 3) {
      dropDownYear = (currentYear - 1) + '-' + currentYear;
    } else {
      dropDownYear = currentYear + '-' + (currentYear + 1);
    }

    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data => {
      this.yearDropDownList = data['data'];
    });
    // console.log("yrslist",this.yearDropDownList);    
    this.selectedYearMonth['ay'] = dropDownYear;
    this.activDeactivYear = (currentYear) + '-' + (currentYear + 1);
  }

  getCurrentMonth() {
    let currentmonth = new Date().getMonth();
    this.monthList.forEach(monthObj => {
      if (monthObj['key'] == currentmonth + 1) {
        this.selectedYearMonth['month'] = monthObj['key'];
      }
    })
  }

  respectiveMonthYear() {
    this.monthList.forEach(month => {
      if (this.selectedYearMonth['month'] == month['key']) {
        this.currentMonthVar = month['value']
      }
    });

    // this.yearList.forEach(year => {
    //   if(this.selectedYearMonth['ay'] == year['value']){
    //     this.currentYearVar = year['key']

    //   }
    // })
    // let yearVar;
    // yearVar = this.selectedYearMonth['ay'].split('-');

    // if(this.selectedYearMonth['month'] < 4){
    //   this.selectedYear = yearVar[1];
    // }else{
    //   this.selectedYear = yearVar[0];
    // }
  }

  getThemes() {
    let options = {
      "ay": this.selectedYearMonth['ay']
    };
    this.submitdataSerivce.FetchIndicators(options).subscribe(data => {
      this.themeData = [];
      data.forEach(theme => {
        if (theme['label'] != null && theme['label'] != 'Meeting at DGC ') {
          this.themeData.push(theme);
        }
      });
      this.prefillMandateThemes();
    })
    this.respectiveMonthYear();
  }

  prefillMandateThemes() {
    let payload = {
      "aY": this.selectedYearMonth['ay'],
      "cUUID": "f78f615d-e270-4f93-90ac-27608e756b85",
      "pUUID": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "component": 1,
      "cType": "DISTRICT",
      "subTp": this.selectedYearMonth['month']
    }
    this.submitdataSerivce.getEnabledThemes(payload).subscribe(result => {
      this.enabledThemes = JSON.parse(result['data']);
      // console.log("before if",this.enabledThemes);
      if (this.enabledThemes != null) {
        this.themeData.forEach(baseTheme => {
          this.enabledThemes.forEach(compTheme => {
            if (baseTheme['entityUUID'] == compTheme['id']) {
              baseTheme['mandate'] = "yes";
              // console.log("basetheme",baseTheme);        
            }
          })
        })
      }
    })
  }

  selectTheme(theme) {
    theme['mandate'] = "yes";
    this.selectedThemes.push({ "id": theme['entityUUID'], "value": theme['mandate'] });
  }

  submitMandateThemes() {
    let postdata = {
      "aY": this.selectedYearMonth['ay'],
      "cUUID": "f78f615d-e270-4f93-90ac-27608e756b85",
      "pUUID": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "component": 1,
      "cType": "DISTRICT",
      "subTp": this.selectedYearMonth['month'],
      "data": JSON.stringify(this.selectedThemes),
    }
    this.submitdataSerivce.updateEnabledThemes(postdata).subscribe(data => {
      if (data.status) {
        this.toastr.success(data.msg);
      } else {
        this.toastr.error(data.msg)
      }

    })

  }

  resetMandateThemes() {
    for (let i = 0; i < this.themeData.length; i++) {
      if (this.themeData[i]['mandate']) {
        this.themeData[i]['mandate'] = null;
      }
    }
    this.selectedThemes = [];
  }

  setActivateYear() {
    let postData = {
      "aY": "2022-2023",
      "cUUID": "f78f615d-e270-4f93-90ac-27608e756b85",
      "pUUID": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "component": 1,
      "cType": "DISTRICT",
      "subTp": "00",
      "data": JSON.stringify([this.activDeactivYear])
    }
    this.submitdataSerivce.insertYearToDisplay(postData).subscribe(result => {
      // console.log("result",result);
      if (result.status) {
        this.toastr.success(result.msg)
      } else {
        this.toastr.error(result.msg)
      }
      this.getdynamicYears();
    });
  }

  setDeactivateYear() {
    let postData = {
      "aY": this.activDeactivYear,
      "cUUID": "f78f615d-e270-4f93-90ac-27608e756b85",
      "pUUID": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "component": 1,
      "cType": "DISTRICT",
      "subTp": "00",
    }
    this.submitdataSerivce.removeYearFromDisplay(postData).subscribe(result => {
      // console.log("result",result);
      if (result.status) {
        this.toastr.success(result.msg)
      } else {
        this.toastr.error(result.msg)
      }
      this.getdynamicYears();
    });
  }
}
